<div *ngIf='selected' class='tab'>
  <ng-content></ng-content>
</div>
